export default "__VITE_ASSET__DDn910w6__"